import React from 'react';
import RouteCardFunctional from './components/route-card-functional';
import './route-card.scss';

const RouteCard = () => {
	return <RouteCardFunctional />;
};

export default RouteCard;
